module.exports = __webpack_public_path__ + "80836582cbfd72e3e3302ff0846f10fc.pdf";